import simpleModal from "./simpleModal";

export default () => {
    const dispatcher = new class {
        constructor() {
            this.onCancel = ugid => console.debug(`cancel ${ugid}`)
            this.onPayment = ugid => console.debug(`payment ${ugid}`)
            this.onSubscribe = uid => console.debug(`subscirbe ${uid}`)
            this.onClose = () => console.debug('close')
        }

        /**
         * @param handler handler, called with subscription id as an argument
         */
        cancel(handler) {
            this.onCancel = handler
            return this
        }

        /**
         * @param handler handler, called with subscription id as an argument
         */
        payment(handler) {
            this.onPayment = handler
            return this
        }

        /**
         * @param handler handler, called with user id as an argument
         */
        subscribe(handler) {
            this.onSubscribe = handler
            return this
        }

        /**
         * @param handler handler, called without arguments
         */
        close(handler) {
            this.onClose = handler
            return this
        }
    }
    const modal = new simpleModal({id: 'AdminSubscribe', small: true, bodyClass: ' '})

    let modalResult = () => dispatcher.onClose()

    const resolveModal = (callback, args = []) => {
        modalResult = () => callback(...args);
        modal.hide()
    }

    const updateControls = () => {
        modal.$.find('[data-show]').closest('.form-group').hide()
        const selectorId = modal.$.find('[data-show]:first').data('selector')
        const selected = modal.$.find(selectorId + ' input:checked').val()
        if (selected) {
            modal.$.find(`[data-show="${selected}"]`).closest('.form-group').show()
        }
    }

    const loadForm = async options => {
        return new Promise((r, e) => {
            $.ajax(options)
                .statusCode({
                    201: content => resolveModal(dispatcher.onSubscribe, [content]),
                    200: content => {
                        modal.setContent(content, true).show()
                        if (window.group) {
                            modal.$.find('.window-header-title').append('<div class="group-title">' + window.group.name + '</div>')
                        }
                        updateControls()
                        r()
                    },
                    409: content => {
                        // This is actually unreachable until some runtime conflict happened.
                        console.error(content)
                        window.openAlert(content['message'], 'success');
                    }
                })
        })
    }

    const loadSearchForm = async () => {
        await loadForm({url: '/site/subscriptions/search-member', data: {cid, gid}})
        modal.$.find('input[type="radio"]:first').trigger('change')
    }


    modal.$.on('closed.cc.modal', () => modalResult())
    modal.$.on('change', 'input[type="radio"]', updateControls)
    modal.$.on('submit', 'form.ajax-form', function (e) {
        e.preventDefault()
        e.stopPropagation()
        const form = $(this)
        loadForm({
            url: form.attr('action'),
            type: form.attr('method'),
            processData: false,
            contentType: false,
            data: new FormData(this),
        }).catch(error => {
            window.openAlert(error.responseText, 'error')
        })
        return false
    })
    modal.$.on('click', '#subscription-actions button[data-name]', function (e) {
        const acts = {
            pay: dispatcher.onPayment,
            cancel: dispatcher.onCancel,
            subscribe: dispatcher.onSubscribe,
            close: dispatcher.onClose,
        }
        const action = $(this).data('name')
        console.debug(acts[action] === undefined ? 'action undefined' : resolveModal(acts[action], [$(this).data('id')]))
    })

    loadSearchForm()
    return dispatcher
}
